"use client"

import { Trash2, RefreshCw } from "lucide-react"

interface Props {
  variant: "update" | "delete"
  loading?: boolean
  onConfirm: () => void
  onCancel: () => void
}

export function PublicLinkConfirmDialog({ variant, loading, onConfirm, onCancel }: Props) {
  const isDelete = variant === "delete"
  const title = isDelete ? "Delete Public Link" : "Update Public Link"
  const description = isDelete
    ? "Deleting this link will revoke access for users accessing with current link."
    : "Updating this link will revoke access for users accessing with previous link."
  const confirmLabel = isDelete ? "Delete" : "Update"
  const confirmLoadingLabel = isDelete ? "Deleting…" : "Updating…"

  return (
    <div
      className="fixed inset-0 z-[10000] flex items-center justify-center"
      style={{ backgroundColor: "rgba(0,0,0,0.35)" }}
      onMouseDown={onCancel}
    >
      <div
        className="w-[300px] bg-[var(--db-dialog-bg)] rounded-2xl shadow-2xl px-6 py-6 flex flex-col items-center text-center"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div
          className="w-12 h-12 rounded-full flex items-center justify-center mb-3"
          style={{ backgroundColor: isDelete ? "#FEE2E2" : "#DBEAFE" }}
        >
          {isDelete ? (
            <Trash2 className="w-5 h-5 text-red-500" />
          ) : (
            <RefreshCw className="w-5 h-5 text-blue-500" />
          )}
        </div>
        <h3 className="text-[15px] font-semibold text-[var(--db-dialog-text)] mb-1">{title}</h3>
        <p className="text-[12px] text-[var(--db-dialog-text-muted)] leading-relaxed mb-5">{description}</p>
        <div className="flex gap-2 w-full">
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className={`flex-1 py-2 text-[13px] font-semibold text-white rounded-xl transition-colors disabled:opacity-50 ${
              isDelete ? "bg-red-500 hover:bg-red-600" : "bg-blue-500 hover:bg-blue-600"
            }`}
          >
            {loading ? confirmLoadingLabel : confirmLabel}
          </button>
          <button
            type="button"
            onClick={onCancel}
            disabled={loading}
            className="flex-1 py-2 text-[13px] font-medium text-[var(--db-dialog-text-muted)] hover:bg-[var(--db-surface-hover)] rounded-xl transition-colors disabled:opacity-50"
            style={{ backgroundColor: "var(--db-tag-bg)" }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}
